import { render, staticRenderFns } from "./addContestant.vue?vue&type=template&id=4c499731&scoped=true&"
import script from "./addContestant.vue?vue&type=script&lang=ts&"
export * from "./addContestant.vue?vue&type=script&lang=ts&"
import style0 from "./addContestant.vue?vue&type=style&index=0&id=4c499731&lang=scss&scoped=true&"
import style1 from "./addContestant.vue?vue&type=style&index=1&id=4c499731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c499731",
  null
  
)

export default component.exports